import { AlertData } from "./alertsInterfaces";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { handleAlertButtonsFill } from "./handleAlertButtonsFill";
import { getActiveIgnoreZones } from "./getActiveIgnoreZones";
import { checkForRedirectAndFetchMP4 } from "./checkForRedirectAndFetchMP4";
import {
  getVideoUrlCacheKey,
  isFetchInProgressForRow,
} from "./videoUrlCache";

export const handleRowSelected = (
  row: any,
  alertData: AlertData[],
  setAlertData: Dispatcher<AlertData[]>,
  setSelectedButtonsFilled: Dispatcher<any>,
  setSeeMoreURL: Dispatcher<string>,
  navigate: NavigateFunction,
  setMP4URL: Dispatcher<string>,
  setVideoClipLoading: Dispatcher<boolean>,
  setSelectedRow: any,
  setSelectedAlertCameraInfo: any,
  setIgnoreZonesSelectedAlert: any,
  refreshingToken: boolean,
  visibleRows: any,
  setBackArrowDisabled: Dispatcher<boolean>,
  setForwardArrowDisabled: Dispatcher<boolean>,
  setShowRefreshButton: Dispatcher<boolean>,
  getCurrentSelectedRowKey?: () => string | null,
  setVideoProcessing?: Dispatcher<boolean>,
  useAsyncGeneration: boolean = true,
  setSelectedRowRef?: (row: any) => void
) => {
  // Handle null row gracefully
  if (!row) {
    setSelectedRow(null);
    return;
  }

  // Hard reset video immediately on selection change so we never keep showing a previous row's clip
  const cacheKey = getVideoUrlCacheKey(row);
  const fetchAlreadyInProgress = isFetchInProgressForRow(cacheKey);
  if (!fetchAlreadyInProgress) {
    setMP4URL("");
    setVideoClipLoading(true);
  }
  setShowRefreshButton(false);

  setSelectedRow(row);
  if (setSelectedRowRef) {
    setSelectedRowRef(row);
  }

  localStorage.setItem("selectedRowAlerts", JSON.stringify(row));

  setIgnoreZonesSelectedAlert([]);

  setSelectedAlertCameraInfo({});

  const currentIndex = visibleRows.findIndex(
    (alert: any) =>
      (alert?.id && row?.id && alert.id === row.id) ||
      (alert.approx_capture_timestamp === row.approx_capture_timestamp &&
        alert.window_id === row.window_id)
  );

  if (currentIndex < 0 || visibleRows.length === 0) {
    setForwardArrowDisabled(true);
    setBackArrowDisabled(true);
  } else {
    const singleRow = visibleRows.length === 1;
    setBackArrowDisabled(singleRow || currentIndex === 0);
    setForwardArrowDisabled(
      singleRow || currentIndex === visibleRows.length - 1
    );
  }

  if (!refreshingToken) {
    if (row) {
      // if (!row.camera_pk) {
      //   const newAlertData = alertData;
      //   newAlertData.forEach((object: AlertData) => {
      //     object.selected = false;
      //   });
      //   newAlertData.forEach((object: AlertData, index: number) => {
      //     if (
      //       `${row.approx_capture_timestamp}${row.camera_name}` ===
      //       `${object.approx_capture_timestamp}${object.camera_name}`
      //     ) {
      //       newAlertData[index].selected = true;
      //     }
      //   });
      //   setSeeMoreURL(row.alert_url);
      //   setAlertData(newAlertData);
      //   setMP4URL("");
      //   setVideoClipLoading(false);
      //   alert(
      //     "This camera has not been added to this site, therefore video can not be retrieved. Please navigate to this site's page and add the camera"
      //   );
      // }
      // if (row.camera_pk) {
      handleAlertButtonsFill(row, setSelectedButtonsFilled);
      const newAlertData = alertData;
      newAlertData.forEach((object: AlertData) => {
        object.selected = false;
      });
      newAlertData.forEach((object: AlertData, index: number) => {
        if (
          (row?.id && object?.id && row.id === object.id) ||
          (row.approx_capture_timestamp === object.approx_capture_timestamp &&
            row.window_id === object.window_id)
        ) {
          newAlertData[index].selected = true;
        }
      });
      setSeeMoreURL(row.alert_url);
      setAlertData(newAlertData);
      if (setVideoProcessing) {
        checkForRedirectAndFetchMP4(
          row,
          navigate,
          setMP4URL,
          setVideoClipLoading,
          setShowRefreshButton,
          true, // Enable caching for row selection
          getCurrentSelectedRowKey,
          setVideoProcessing,
          useAsyncGeneration
        );
      } else {
        checkForRedirectAndFetchMP4(
          row,
          navigate,
          setMP4URL,
          setVideoClipLoading,
          setShowRefreshButton,
          true, // Enable caching for row selection
          getCurrentSelectedRowKey,
          setVideoProcessing,
          useAsyncGeneration
        );
      }
      // AxiosMonUI.get(
      //   `alert/clip/?approx_capture_timestamp=${row.approx_capture_timestamp}&window_id=${row.window_id}`
      // ).then(
      //   (response: AxiosResponse) => {
      //     const selectedRowAlerts = JSON.parse(
      //       localStorage.selectedRowAlerts
      //     );
      //     if (
      //       row.approx_capture_timestamp ===
      //       selectedRowAlerts.approx_capture_timestamp
      //     ) {
      //       setMP4URL(response.data);
      //       setVideoClipLoading(false);
      //     }
      //   },
      //   (reason: AxiosError) => {
      //     universalAPIErrorHandler(reason, navigate, retryFunction, () => {
      //       setTimeout(() => {
      //         setVideoClipLoading(false);
      //       }, 2000);
      //     });
      //   }
      // );
      // }
    }
  }
};
